import React, { useContext } from 'react'
import styles from './cover.module.scss'
import { PartyChart } from 'components/partyChart'
import { LocaleContext } from 'contexts/locale'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

export function Cover() {
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  /** Title – by default this is the Zürich version */
  let title = messages.title.zh

  switch (parseHostname().publicationName) {
    case 'bazonline':
      title = messages.title.bs
      break

    case 'bernerzeitung':
    case 'derbund':
    case 'berneroberlaender':
    case 'thunertagblatt':
    case 'langenthalertagblatt':
      title = messages.title.be
      break
  }

  return (
    <div className={styles.cover}>
      <div className='ui container'>
        <h1
          className={`ui grey header ${styles.header} ${styles.reducedFontSize}`}
        >
          {title}
        </h1>
        <h2 className={`ui header ${styles.lead}`}>
          <div className='sub header'>{messages.lead}</div>
        </h2>
        <div
          className='ta author'
          dangerouslySetInnerHTML={{ __html: messages.authors }}
        />
      </div>
      <PartyChart />
    </div>
  )
}
